import { styled, Box } from '@mui/material'

export const TemplateImageWrapper = styled('div')({
  height: '650px',
  width: '700px',
  position: 'relative',
  marginTop: '30px',
  border: '2px solid #ecedf0',
  borderRadius: '5px',
  overflow: 'hidden',
});

export const CommunicationInfo = styled('ul')({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  fontSize: '16px',
  color: 'black',
  '& li': {
    marginBottom: '10px',
    display: 'flex',

    '& > div': {
      width: '58px',
      textAlign: 'right',
      fontWeight: 500,
      marginRight: '4px',
    }
  },
});